import axios from 'axios';

export default {
  namespaced: true,
  state: {
    financereports: [],
    isFetching: false,
    isReceiving: false,
    hasAlert: false,
    isDone: false,
    report: null,
    idToDelete: null,
  },
  mutations: {
    SET_REPORT(state, payload) {
      state.report = payload;
      console.log(state.report)
    },
    RECEIVED_FINANCE_REPORTS(state, payload) {
      state.financereports = payload;
      state.isReceiving = false;
    },
    STOP_RECEIVING(state) {
      state.isReceiving = false;
    },
    RECEIVING_FINANCE_REPORTS(state) {
      state.isReceiving = true;
    },
    FINANCE_REPORT_FAILURE(state, payload) {
      state.isFetching = false;
      state.hasAlert = true;
      state.errorMessage = payload;
    },
    FINANCE_REPORT_SUCCESS(state) {
      state.isFetching = false;
      state.hasAlert= false;
      state.errorMessage = '';
      state.isDone = true;
    },
    FINANCE_REPORT_REQUEST(state) {
      state.isFetching = true;
      state.hasAlert= false;
      state.errorMessage = '';
    },
    FINANCE_REPORT_DONE(state) {
      state.isFetching= false,
      state.hasAlert = false,
      state.isDone = false,
      state.errorMessage = ''
    }
  },
  actions: {
    async setReport({commit}, payload) {
      commit("SET_REPORT", payload);
    },
    async getFinanceReportPayablesRequest({dispatch}, payload) {
      try{
        dispatch("receivingFinanceReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/get/finance/report/ap';
        let response = await axios({method: "get", url: url, headers: headers, data: payload});
        dispatch("receiveFinanceReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getFinanceReportPayablesAgingRequest({dispatch}, payload) {
      try{
        dispatch("receivingFinanceReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/get/finance/report/ap-aging';
        let response = await axios({method: "get", url: url, headers: headers, data: payload});
        dispatch("receiveFinanceReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getFinanceReportReceivablesRequest({dispatch}, payload) {
      try{
        dispatch("receivingFinanceReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/get/finance/report/ar';
        let response = await axios({method: "get", url: url, headers: headers, data: payload});
        dispatch("receiveFinanceReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getFinanceReportReceivablesAgingRequest({dispatch}, payload) {
      try{
        dispatch("receivingFinanceReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

        let url = 'https://api.accountxc.com:3100/get/finance/report/ar-aging';
        let response = await axios({method: "get", url: url, headers: headers, data: payload});
        dispatch("receiveFinanceReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findFinanceReportPayablesRequest({dispatch}, payload) {
      try{
        dispatch("receivingFinanceReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/finance/report/ap';
        
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveFinanceReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findFinanceReportReceivablesRequest({dispatch}, payload) {
      try{
        dispatch("receivingFinanceReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/finance/report/ar';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveFinanceReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async findFinanceReportReceivablesAgingRequest({dispatch}, payload) {
      try{
        dispatch("receivingFinanceReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/finance/report/ar-aging';
        
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveFinanceReports", response.data);
        return response.data;
      }
      catch(e){
        console.log(e)
        return null;
      }
    },
    async findFinanceReportPayablesAgingRequest({dispatch}, payload) {
      try{
        dispatch("receivingFinanceReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/find/finance/report/ap-aging';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveFinanceReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    receiveFinanceReport({dispatch}) {
      dispatch('receivedFinanceReport');
    },
    receiveFinanceReports({commit}, payload) {
      commit("RECEIVED_FINANCE_REPORTS", payload)
    },
    receivingFinanceReports({commit}) {
      commit("RECEIVING_FINANCE_REPORTS")
    },
    resetFinanceReport({commit}) {
      commit('FINANCE_REPORT_DONE');
    },
    receivedFinanceReportSuccess({commit}) {
      commit('FINANCE_REPORT_SUCCESS');
    },
    requestFinanceReport({commit}) {
      commit('FINANCE_REPORT_REQUEST');
    },
  }
}
